import React from "react";
import Icon from '../Icon';
import styles from './SearchInput.module.sass';
import cn from 'classnames';

const SearchInput = ({className, onChange, value}) => {

    return <div className={cn(styles.searchContainer, className)}>
        
        <input
            className={styles.input}
            type='text'
            name='search'
            placeholder='Search People'
            onChange={(event) => {onChange?.(event.target.value)}}
            value={value}
        />
        <button><Icon className={styles.icon} name='search' size='28' /></button>
    </div>

};

export default SearchInput;
